import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdministratorService } from 'src/app/core/servicie/administrador.service';
import { CustomerService } from 'src/app/core/servicie/customer.service';
import { IParametric } from 'src/app/shared/interfaces/parametric.interface';
import { Validatorsforms } from 'src/app/shared/validators/validators';
import { environment } from 'src/environments/environment';


import Swal from 'sweetalert2';

@Component({
  selector: 'app-form-community',

  templateUrl: './form-community.component.html',
  styleUrls: ['./form-community.component.scss']
 
 
  
})
export class FormCommunityComponent implements OnInit {
  formGodzilla: FormGroup;
  submitAttempted = false;
  listThematic:IParametric[]=[];
  loading:boolean=false;
  selectOptions:string[]=[];
  urlPolitics=environment.titanWebUrl+"/terminos-y-condiciones/";
  titanIdString="";
  currentPage: number = 1;
  validatorexpressions = Validatorsforms;
  constructor(private formBuilder: FormBuilder,
    private administratorService:AdministratorService,
    private route: ActivatedRoute,
    private customerService:CustomerService,
    private router: Router) {
    this.formGodzilla = this.formBuilder.group({
      name: ['', [Validators.required,Validators.maxLength(40)]],
      lastName: ['', [Validators.required,Validators.maxLength(80)]],
      phoneNumber: ['', [Validators.required,Validators.min(1000000000),Validators.max(999999999999999)]],
      email: ['', [Validators.required,Validators.maxLength(40),Validators.pattern(this.validatorexpressions.email)]],
      documentType : [null],
      document : [null],
      thematics:[[]],
      titanId:[''],
      utm_source:[''],
      utm_medium:[''],
      utm_campaign:[''],
      utm_content:[''],
      politics:[false,Validators.requiredTrue],
      campoenvio:[''],
      fullName:['']
    });
  }
  
  checkFormBeforeProceed(): void {
    if (this.formGodzilla.invalid) {
      this.submitAttempted = true; // Marca el intento de envío
      // No navegues a la siguiente página
    } else {
      this.goToPage(2);
    }
  }
  
  goToPage(pageNumber: number): void {
    this.currentPage = pageNumber;
  }
  limitLong(event: any) {
    const value=event.target.value;
    const maxLength = 15;
    if (value && value.length > maxLength) {
      const truncatedValue = value.substring(0, maxLength);
      this.formGodzilla.patchValue({ phoneNumber: truncatedValue }, { emitEvent: false });
    }
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if(params['titanId']){
        this.titanIdString=params['titanId'];
      }
      if(params['email']){
        this.formGodzilla.patchValue({
          email:params['email']
        })
      }
      if(params['utm_source']){
        this.formGodzilla.patchValue({
          utm_source:params['utm_source']
        })
      }
      if(params['utm_medium']){
        this.formGodzilla.patchValue({
          utm_medium:params['utm_medium']
        })
      }
      if(params['utm_content']){
        this.formGodzilla.patchValue({
          utm_content:params['utm_content']
        })
      }
      if(params['utm_campaign']){
        this.formGodzilla.patchValue({
          utm_campaign:params['utm_campaign']
        })
      }
      this.selectOptions=[];
      for (const property in params) {
        this.selectOptions.push(property.toUpperCase());
      }

      this.reloadThematic(true);
    });
    
  }
  
  reloadThematic(flagLoader:boolean){
    this.administratorService.getSuperGroup("Es").subscribe(dataThematic=>{
      this.listThematic=dataThematic;
      if(!flagLoader){
        const themathicsTemp=sessionStorage.getItem("listThematicTemp");
        if(themathicsTemp){
          this.listThematic=JSON.parse(themathicsTemp);
        }
      }else{
        sessionStorage.clear();
      }
      if(this.selectOptions.length>0){
        this.listThematic.forEach(item => {
          item.thematics.forEach(subtheme => {
            if (this.selectOptions.includes(subtheme.code)) {
              subtheme.selected = true;
            }
          });
        });
      }

    });
  }

  updateThematics(obj:any,newData:any){
    obj=newData;
    sessionStorage.setItem("listThematicTemp",JSON.stringify(this.listThematic));
  }

  formIsValid(){
    let result = this.listThematic.map(x => {
      let ThematicsSelect = x.thematics.filter(y => y.selected === true);
      return ThematicsSelect.length > 0;
    });
    let isSelect=result.filter(x=>x===true);
    if(isSelect.length>0 && !this.formGodzilla.invalid){
      return false;
    }else{
      return true;
    }
  }

  sendFormGodzilla(){
    this.submitAttempted = true;
    var ThematicsTemporary: string[]=[];
    this.listThematic.map(x=>{
      var ThematicsSelect=x.thematics.filter(y=>y.selected==true);
      ThematicsSelect.forEach(element => {
        ThematicsTemporary.push(element.code);
      });
    });
    const name= this.formGodzilla.get("name")?.value;
    const lastName= this.formGodzilla.get("lastName")?.value;
    const phone= this.formGodzilla.get("phoneNumber")?.value;
    const email= this.formGodzilla.get("email")?.value;
    const utm_source= this.formGodzilla.get("utm_source")?.value;
    const utm_medium= this.formGodzilla.get("utm_medium")?.value;
    const utm_campaign= this.formGodzilla.get("utm_campaign")?.value;
    const utm_content= this.formGodzilla.get("utm_content")?.value;
    this.formGodzilla.patchValue({
      thematics:ThematicsTemporary,
      titanId:this.titanIdString,
      fullName:`${name} ${lastName}`,
      email:email,
      utm_source:utm_source,
      utm_content:utm_content,
      utm_campaign:utm_campaign,
      utm_medium:utm_medium,
      phoneNumber:phone.toString()
    });
    this.loading=true;
    this.customerService.ThematicSubscription(this.formGodzilla.getRawValue(),this.titanIdString).subscribe(data=>{
      this.loading=false;
      this.reloadThematic(true);
      Swal.fire({
        title: '<p class="titleAlert"><span class="laberAlert">Te suscribiste exitosamente a las publicaciones</span> seleccionadas, pronto te las compartiremos.</p>',
        icon: 'success',
        confirmButtonText: 'Salir',
        customClass: {
          confirmButton: 'buttonAlertConfirm' 
        }
      })
      this.formGodzilla.reset();
    },error=>{
      this.loading=false;
    })

    const formData = this.formGodzilla.getRawValue();
  window.parent.postMessage({ action: 'submitForm', formData: formData }, '*');
}

}
